import type { SVGAttributes } from "react";

export function ArrowIcon({
  className,
  width,
  height,
  fill,
}: SVGAttributes<unknown>) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <g id="Group_901" data-name="Group 901">
          <g id="Group_900" data-name="Group 900">
            <path
              fill={fill}
              d="M12.73,17.48a.57.57,0,0,1-.41-.16.6.6,0,0,1,0-.85l6.56-6.88a.6.6,0,0,1,.87.82L13.17,17.3A.62.62,0,0,1,12.73,17.48Z"
            />
            <path
              fill={fill}
              d="M19.29,10.6a.56.56,0,0,1-.43-.19L12.3,3.53a.6.6,0,0,1,0-.85.61.61,0,0,1,.85,0l6.56,6.89a.6.6,0,0,1,0,.84A.63.63,0,0,1,19.29,10.6Z"
            />
          </g>
          <path
            fill={fill}
            d="M19.29,10.6H.71a.6.6,0,0,1,0-1.2H19.29a.6.6,0,0,1,0,1.2Z"
          />
        </g>
      </svg>
    </>
  );
}
